import "./ButtonLoader.css";

const ButtonLoader = () => {
  return <div className="dot-elastic"></div>;
};

export default ButtonLoader;
